import { render, staticRenderFns } from "./LighthouseLeadOrdersPage.vue?vue&type=template&id=5b1df7e6&"
import script from "./LighthouseLeadOrdersPage.vue?vue&type=script&lang=js&"
export * from "./LighthouseLeadOrdersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports